import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Users, GraduationCap, Heart, MessageSquare } from 'lucide-react';
import Newsletter from '../components/Newsletter';
import { getInvolvedItems } from '../mock';

const icons = [Users, GraduationCap, Heart, MessageSquare];

const GetInvolved = () => (
  <div>
    <section className="pt-[140px] pb-12 px-6 lg:px-10">
      <div className="max-w-[1100px] mx-auto fade-up">
        <span className="dctv-eyebrow text-[#e8743b]">Get involved</span>
        <h1 className="font-serif-dctv text-5xl md:text-6xl font-bold text-white mt-5">Join the DCTV community</h1>
        <p className="text-[#bcc3cf] text-lg leading-relaxed mt-6 max-w-2xl">
          DCTV depends on the strength of its volunteers, interns and supporters. There are many ways to lend your voice and creativity.
        </p>
      </div>
    </section>

    <section className="px-6 lg:px-10 pb-16">
      <div className="max-w-[1100px] mx-auto grid sm:grid-cols-2 gap-6">
        {getInvolvedItems.map((item, i) => {
          const Icon = icons[i];
          return (
            <div key={item.title} className="dctv-card rounded-2xl p-8 flex flex-col">
              <Icon className="w-7 h-7 text-[#e8743b]" />
              <h3 className="font-serif-dctv text-2xl font-semibold text-white mt-4">{item.title}</h3>
              <p className="text-[#9aa3b2] text-sm leading-relaxed mt-3 flex-1">{item.text}</p>
              <Link to={item.to} className="inline-flex items-center gap-2 mt-6 text-[#e8743b] font-semibold text-sm group">
                {item.cta} <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
              </Link>
            </div>
          );
        })}
      </div>
    </section>

    <Newsletter />
  </div>
);

export default GetInvolved;
